import axios from "axios";
import { BASE_URL_USER } from "../../Config/BaseUrl";
import { sessionToken } from "../../utils/storageHelper";

const createAxiosConfig = (url, method, data, useAuth = true) => {
  const headers = { "Content-Type": "application/json" };

  // ✅ Only set JSON Content-Type when NOT sending FormData
  if (!(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  if (useAuth) {
    const token = sessionToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  return {
    method,
    url: `${BASE_URL_USER}${url}/`,
    headers,
    data,
  };
};

export const AuthApisUser = {
  UserLogin: async (data) => {
    const axiosConfig = createAxiosConfig("/login", "POST", data, false);
    return await axios(axiosConfig);
  },

  GetAssessment: async () => {
    // Use the same createAxiosConfig helper
    const axiosConfig = createAxiosConfig("/assessment", "GET", null, true);
    return await axios(axiosConfig);
  },

  SubmitAssessment: async (data) => {
    const axiosConfig = createAxiosConfig(
      `/submit_assessment`,
      "post",
      data,
      true
    );
    return await axios(axiosConfig);
  },

  //  EmailResult: async (data) => {
  //   const axiosConfig = createAxiosConfig(`/send_uploaded_pdf`, "post", data, true);
  //   if (data instanceof FormData) {
  //     axiosConfig.headers["Content-Type"] = "multipart/form-data";
  //   }
  //   return await axios(axiosConfig);
  // },

  EmailResult: async (data) => {
    const axiosConfig = createAxiosConfig(
      `/send_uploaded_pdf`,
      "post",
      data,
      true
    );

    // If it's FormData, LET axios set headers automatically
    if (data instanceof FormData) {
      delete axiosConfig.headers["Content-Type"];
    }

    return await axios(axiosConfig);
  },
};
